/**
 * ThankYouMap Component
 *
 * Full-width static Google Maps embed showing the property's single location.
 * Uses the same Google Maps Embed API approach as NeighborhoodMap but renders
 * only the map — no POI list, no description text.
 */

import {
  useContentToken,
  EditableToken,
} from '@vibesites/runtime/react';
import type { ComponentContentSchema } from '@vibesites/runtime';

export function ThankYouMap() {
  const address = useContentToken('thankyoumap.address');

  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(address || '')}&zoom=14`;

  return (
    <section className="relative w-full" style={{ height: 'clamp(300px, 50vw, 500px)' }}>
      <div className="absolute w-px h-px overflow-hidden" style={{ clip: 'rect(0,0,0,0)' }}>
        <EditableToken path="thankyoumap.address" type="text" label="Map Address">
          {address}
        </EditableToken>
      </div>
      <iframe
        className="absolute inset-0 w-full h-full border-none"
        src={mapUrl}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Property location map"
      />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ThankYouMap',
  displayName: 'Thank You Map',
  tokens: {
    'thankyoumap.address': {
      label: 'Map Address',
      type: 'text',
      description: 'Full address used for the embedded map',
      defaultField: 'property_full_address',
      defaultValue: '123 Main Street',
    },
  },
};

(ThankYouMap as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ThankYouMap;
